module.exports = __webpack_public_path__ + "content/43e82fa53e03e87340f93865a1fcf99e.svg";